document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.sms-support-label').forEach((label) => {
    label.parentNode.href = label.parentNode.href.replace('tel:', 'sms:');
  });
});

getDeviceType = function() {
  if(window.innerWidth < 1000 ) {
    return 'Mobile';
  } else {
    return 'Desktop';
  };
};

var fixOptanonCookies = function() {
  var deleteAllOptanonCookies = function() {
    document.cookie = 'OptanonConsent=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=halfdaytravel.com';
    document.cookie = 'OptanonConsent=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.halfdaytravel.com';
    document.cookie = 'OptanonConsent=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  };

  var extractDatestamp = function(cookieValue) {
    var decoded = decodeURIComponent(cookieValue);
    var startPosition = decoded.indexOf('datestamp=');
    if (startPosition === -1) { return; }

    startPosition += 'datestamp='.length;
    var endPosition = decoded.indexOf('&', startPosition);

    if (endPosition === -1) {
      endPosition = decoded.length;
    }
  
    var datestamp = decoded.substring(startPosition, endPosition).replace(/\+/g, ' ');

    var date = new Date(datestamp);
    if (isNaN(date.getTime())) {
      return;
    }

    return date;
  }

  var cutoffDate = new Date('2025-04-26');
  var cookies = document.cookie.split(';')
  var optanonCookiesFound = 0;

  cookies.forEach(function(cookie){
    var separatorIndex = cookie.indexOf('=');
    if (separatorIndex != -1) {
      var cookieName = cookie.substring(0, separatorIndex).trim();
      
      if (cookieName === 'OptanonConsent') {
        console.log('Found one OptanonConsent Cookie');
        var cookieValue = cookie.substring(separatorIndex + 1);
        var datestamp = extractDatestamp(cookieValue);
  
        if(datestamp && datestamp < cutoffDate) {
          optanonCookiesFound++;
        }
      }
    }
  });

  if(optanonCookiesFound > 1) {
    console.log("We found several optanon cookies: ", optanonCookiesFound);
    deleteAllOptanonCookies();
  }
}

try {
  console.log('About to run optanon patch');
  fixOptanonCookies();
} catch (e) {
  console.log('Cookie patch failed: ', e);
}